import { FETCH_USER_IDENTITY_DATA, FETCH_USER_IDENTITY_DATA_FAILED } from '../../actions/userDataActions';

const userIdentityReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_USER_IDENTITY_DATA: {
      return{
      ...state,
      userId:  action.payload.userCipherDetails.userId,
      tokenDetails: action.payload.tokenDetails}
    }
  }
  return state;
}

export default userIdentityReducer;
